export enum MaterialStageEnum {
  "New Construction" = 0,
  "Existing",
  "Demolished",
}
